export default function StatsCard({ title, value }) {
  return (
    <div className="col-md-4">
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <h6 className="text-muted">{title}</h6>
          <h2 className="fw-bold text-primary">{value ?? 0}</h2>
        </div>
      </div>
    </div>
  );
}
